// extracted by css-extract-rspack-plugin
export default {"cls1":"VideoReportModal-cls1_5ne","cls2":"VideoReportModal-cls2_Dqq VideoReportModal-cls1_5ne"};